window.OnlineServicesParticulieren = window.OnlineServicesParticulieren || {};
(function(OnlineServicesParticulieren) {
  "use strict";

  function parseDate(value) {
    if (typeof value.getMonth === "function") {
      return validDate(value.getFullYear(), value.getMonth(), value.getDate())
        ? toString(value.getFullYear(), value.getMonth(), value.getDate())
        : null;
    }

    if (
      value.match(
        /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/
      )
    ) {
      const parts = value.split(/[- /.]/);
      return validDate(parts[2], parts[1], parts[0])
        ? toString(parts[2], parts[1], parts[0])
        : null;
    }

    if (
      value.match(
        /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/
      )
    ) {
      const prts = value.split(/[- /.]/);
      return validDate(prts[0], prts[1], prts[2])
        ? toString(prts[0], prts[1], prts[2])
        : null;
    }
  }

  function validDate(year, month, day) {
    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) {
      return false;
    }

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }

  function displayDate(value) {
    var date = parseDate(value);
    return date
      ? date
          .split("-")
          .reverse()
          .join("-")
      : "";
  }

  function dateToString(date) {
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1, 2) +
      "-" +
      pad(date.getDate(), 2)
    );
  }

  function toString(year, month, day) {
    return year + "-" + pad(month, 2) + "-" + pad(day, 2);
  }

  function pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  OnlineServicesParticulieren.DisplayDate = displayDate;
  OnlineServicesParticulieren.ParseDate = parseDate;
  OnlineServicesParticulieren.DateToString = dateToString;
})(window.OnlineServicesParticulieren);
